import {Ventrata} from 'types'

type PromoDetails = {
  type: 'voucher' | 'offer'
  code: string
  name: string
  value: number
}

export const getDiscountDetails = (order: Ventrata.Order): PromoDetails | null => {
  if (order.giftPayment) {
    return {
      type: 'voucher',
      code: order.giftPayment.giftCode,
      name: 'Gift card',
      value: order.giftPayment.amount,
    }
  }

  for (const booking of order.bookings) {
    if (booking.offer) {
      const original = booking.pricing?.original || 0
      const retail = booking.pricing?.retail || 0

      return {
        type: 'offer',
        code: booking.offer.code,
        name: booking.offer.title,
        value: original - retail,
      }
    }
  }

  return null
}
